import {LinkOutlined} from "@ant-design/icons";
import {
  StyledServiceOrderWorkDeliveryDeliveredWorkCustomerComment,
  StyledServiceOrderWorkDeliveryDeliveredWorkLinkList,
  StyledServiceOrderWorkDeliveryDeliveredWorkLinkListItem,
} from "../../styles";
import {StyledServiceOrderGreyText} from "../../../../../styles";
import {Typography} from "antd";
const {Paragraph} = Typography;

export type ServiceOrderWorkDeliveryDeliveredWorkLinkListProps = {
  links: {
    link: string;
  }[];
  date: string;
};

export type ServiceOrderWorkDeliveryDeliveredWorkLinkListItemProps = {
  link: string;
};

export type ServiceOrderWorkDeliveryDeliveredWorkCustomerReviewProps = {
  customerReviewComment: string;
  date: string;
};

export function ServiceOrderWorkDeliveryDeliveredWorkLinkList({
  links,
  date,
}: ServiceOrderWorkDeliveryDeliveredWorkLinkListProps) {
  return (
    <StyledServiceOrderWorkDeliveryDeliveredWorkLinkList>
      <StyledServiceOrderGreyText>{date}</StyledServiceOrderGreyText>
      {links.map((dwl) => (
        <ServiceOrderWorkDeliveryDeliveredWorkLinkListItem
          key={dwl.link}
          link={dwl.link}
        />
      ))}
    </StyledServiceOrderWorkDeliveryDeliveredWorkLinkList>
  );
}

export function ServiceOrderWorkDeliveryDeliveredWorkLinkListItem({
  link,
}: ServiceOrderWorkDeliveryDeliveredWorkLinkListItemProps) {
  return (
    <StyledServiceOrderWorkDeliveryDeliveredWorkLinkListItem>
      <LinkOutlined />
      <Paragraph className="delivered-work-link-list-item-link-value" copyable>
        {link}
      </Paragraph>
      {/* <a href={link} target="_blank" rel="noreferrer">
        <span className="delivered-work-link-list-item-link-value">{link}</span>
      </a> */}
    </StyledServiceOrderWorkDeliveryDeliveredWorkLinkListItem>
  );
}

export function ServiceOrderWorkDeliveryReviewedDeliveredWorkLinkList({
  links,
}: ServiceOrderWorkDeliveryDeliveredWorkLinkListProps) {
  return (
    <StyledServiceOrderWorkDeliveryDeliveredWorkLinkList>
      <StyledServiceOrderGreyText>Reviewed on July 16, 2025</StyledServiceOrderGreyText>
      {links.map((dwl) => (
        <ServiceOrderWorkDeliveryDeliveredWorkLinkListItem
          key={dwl.link}
          link={dwl.link}
        />
      ))}
    </StyledServiceOrderWorkDeliveryDeliveredWorkLinkList>
  );
}
export function ServiceOrderWorkDeliveryDeliveredWorkCustomerReview({
  customerReviewComment,
  date,
}: ServiceOrderWorkDeliveryDeliveredWorkCustomerReviewProps) {
  return (
    <StyledServiceOrderWorkDeliveryDeliveredWorkLinkList>
      <StyledServiceOrderGreyText>Customer’s review comment</StyledServiceOrderGreyText>
      <StyledServiceOrderWorkDeliveryDeliveredWorkCustomerComment>
        <p>"{customerReviewComment}"</p>
      </StyledServiceOrderWorkDeliveryDeliveredWorkCustomerComment>
      <StyledServiceOrderGreyText>{date}</StyledServiceOrderGreyText>
    </StyledServiceOrderWorkDeliveryDeliveredWorkLinkList>
  );
}
